export default "__VITE_ASSET__C7qvu3W1__"